import React, { useContext, useState } from "react";
import { useQuery } from "react-query";

import { QK } from "../../../base/qk";
import { getNEWS2 } from "../../../api/services/observations";
import { formatDateTime } from "../../../base/FormatTime";
import TableComponent from "../../TableComponent/TableComponent";
import { Chip } from "@mui/material";
import { getRiskLevelColor } from "../../Clients/ClientDetails/WhatElse/Observation/NEWS2/news2.config";
import MyContext from "../../../context/MyContext";

const NEWS2Content = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { locationID } = useContext(MyContext);

  const resultPerPage = 10;

  const { data: news2lists, isLoading } = useQuery(
    [QK.NEWS2lists, currentPage, "", locationID],
    () => getNEWS2(currentPage, "", locationID),
    { keepPreviousData: true, enabled: !!currentPage || !!locationID }
  );

  const totalRecords = news2lists?.count || 0;
  const totalPages = Math.ceil(totalRecords / resultPerPage);

  const handlePageChange = (event, page) => setCurrentPage(page);

  const columns = [
    {
      field: "actioned_time",
      headerName: " Date / Time",
      render: (value) => formatDateTime(value),
    },
    { field: "score", headerName: "Score" },
    {
      field: "risk_level",
      headerName: "Risk Level",
      render: (value) => (
        <Chip label={value} color={getRiskLevelColor(value)} size="small" />
      ),
    },
    { field: "client_name", headerName: "Service User Name" },
    { field: "notes", headerName: "Notes" },
  ];

  return (
    <div>
      <TableComponent
        columns={columns}
        data={news2lists?.results || []}
        isLoading={isLoading}
        pagination={{ totalPages, currentPage }}
        onPageChange={handlePageChange}
        size="medium"
      />
    </div>
  );
};

export default NEWS2Content;
